import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule }                  from '@angular/common';
import { FormsModule }                   from '@angular/forms';
import { CsChartModule }                 from '@cs/components/chart-svg';
import { CsChatComponent }               from './chat.component';
import { CsChatMessageComponent }        from './cs-chat-message.component';
import { CsMarkdownComponent }           from './cs-markdown.component';
import { CsProcessDiagramComponent }     from './diagram/cs-process-diagram.component';
import { CsAnnotatedImageComponent }     from './annotated-image/cs-annotated-image.component';
import { CsElapsedTimeDirective }        from './cs-elapsed-time.directive';
import { CsStickToBottomDirective }      from './cs-stick-to-bottom.directive';
import { CS_CHAT_CONFIG, CsChatConfig }  from './chat.config';

@NgModule({
	imports:      [CommonModule, FormsModule, CsChartModule],
	declarations: [
		CsChatComponent,
		CsChatMessageComponent,
		CsMarkdownComponent,
		CsProcessDiagramComponent,
		CsAnnotatedImageComponent,
		CsElapsedTimeDirective,
		CsStickToBottomDirective
	],
	exports:      [CsChatComponent, CsChatMessageComponent, CsMarkdownComponent]
})
export class CsChatModule {
	static forRoot(config?: CsChatConfig): ModuleWithProviders<CsChatModule> {
		return {
			ngModule:  CsChatModule,
			providers: config ? [{provide: CS_CHAT_CONFIG, useValue: config}] : []
		};
	}
}
